import toastStyles from "../static/messages/styles.scss";
import toastItemHtml from "../static/messages/index.html";
import { ImisMessageType } from "../models/imis.models";
import { ToastMessageProperties } from "../models/messages.models";

export class MessagesUtility {
    public static showMessage(messageId: string, message: string, messageType: ImisMessageType, parentSelector: any) {
        let messageSelector = "#" + messageId;
        let jMessage = jQuery(messageSelector);
        if (jMessage.length == 0) {
            let jParent = jQuery(parentSelector);
            jMessage = jQuery("<p id='" + messageId + "'></p>").hide();
            jParent.append(jMessage);
        }

        jMessage.html(message).attr("class", messageType);
        jMessage.show();
    }

    public static hideMessage(messageId: string) {
        let messageSelector = "#" + messageId;

        let jMessage = jQuery(messageSelector);
        jMessage.hide();
    }

    public static removeMessage(messageId: string) {
        let messageSelector = "#" + messageId;

        let jMessage = jQuery(messageSelector);
        jMessage.remove();
    }

    public static showToastMessage(toastProperties: ToastMessageProperties) {
        toastStyles.use();
        let toastPropertiesWithDefaults = Object.assign(new ToastMessageProperties(), toastProperties);

        // ensure the container already exists
        let jContainer = jQuery(".va-imis-utility-toast");
        if (jContainer.length == 0) {
            jContainer = jQuery("<div class='va-imis-utility-toast'></div>");
            jQuery("body").append(jContainer);
        }

        // ensure the message item already exists
        let jItem = jQuery("#" + toastPropertiesWithDefaults.messageId);
        if (jItem.length == 0) {
            jItem = jQuery(toastItemHtml);
            jItem.attr("id", toastPropertiesWithDefaults.messageId);
            jContainer.append(jItem);
        }

        // setup message item
        jItem.find("span:first-of-type").text(toastPropertiesWithDefaults.message);
        jItem.attr("class", "va-imis-utility-toast-item " + toastPropertiesWithDefaults.messageType);

        let jCloseSpan = jItem.find("span:last-of-type");
        let jButtons = jItem.find("button");
        jButtons.off("click");
        if (toastPropertiesWithDefaults.confirmationDialog != null) {
            // reset any existing click events and setup new button clicks and hide the close span
            jItem.off("click");

            jItem.find("button:first-of-type").on("click", () => {
                toastPropertiesWithDefaults.confirmationDialog.onConfirm();
                jItem.remove();
            });
            jItem.find("button:last-of-type").on("click", () => {
                toastPropertiesWithDefaults.confirmationDialog.onCancel();
                jItem.remove();
            });

            jCloseSpan.hide();
            jButtons.show();
        } else {
            // setup overall click event to dismiss toast
            jItem.on("click", () => {
                jItem.remove();
            });

            if (toastPropertiesWithDefaults.autoDismiss) {
                jItem.delay(toastPropertiesWithDefaults.autoDismissSeconds * 1000).fadeOut(() => {
                    jItem.remove();
                });
            }

            jCloseSpan.show();
            jButtons.hide();
        }
    }
}